import {
  Component, Input, ViewChild, OnInit
} from '@angular/core';
import {ErrorMessageComponent} from "../error-message/error-message.component";
import {FormControl, FormGroup} from "@angular/forms";
import {ValidationService} from "../validation.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-amount-slider',
  templateUrl: './amount-slider.component.html',
  styleUrls: ['./amount-slider.component.sass'],
})
export class AmountSliderComponent implements OnInit{

  @ViewChild(ErrorMessageComponent) error;

  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Input() disableRequiredIdentifier

  public brand;

  ngOnInit() {
    this.brand = environment.brand;
  }

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public validation() {
    return ValidationService.getValidationClass(
      this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
    );
  }

}
